import type { RequestFn } from 'api/useApiRequest';

export interface CrmEmailListItem {
  crmEmailId: number;
  title: string;
  subject: string;
  status: string;
}

export const fetchCrmEmail = (request: RequestFn, { id, signal }: { id: number; signal?: AbortSignal }) =>
  request({
    method: 'get',
    pathname: `/api/crm-email/get/${id}`,
    signal,
    notShowErrorMessage: true,
  });

export const fetchCrmEmails = (
  request: RequestFn,
  {
    signal,
    pageNumber = 1,
    pageSize = 10000,
    sortField = 'lastUpdated',
    sortOrder = 'descending',
  }: {
    signal?: AbortSignal;
    pageNumber?: number;
    pageSize?: number;
    sortField?: string;
    sortOrder?: string;
  } = {}
) =>
  request({
    method: 'get',
    pathname: `/api/crm-email/search?pageNumber=${pageNumber}&sortField=${sortField}&sortOrder=${sortOrder}&pageSize=${pageSize}`,
    signal,
  });
